// extracted by mini-css-extract-plugin
module.exports = {"paper":"a4-qr-20x20_paper__1erU9","page":"a4-qr-20x20_page__16xVD","label":"a4-qr-20x20_label__12jIA","label_unique_id":"a4-qr-20x20_label_unique_id__h5sM8"};